import styled, { css } from "styled-components/native";
import { light_black, spacing_l, white } from "../../StyleHelpers";
import { Props, PropsCommonAttributes } from "./model";

//Narrow
export const TabsNarrowMain = styled.View<any>`
	align-items: flex-start;
	flex: 1 0 0;
	z-index: 1000;
	position: ${(props) => (props.isSettings ? "relative" : "fixed")};
	height: 100%;
`;

export const TabsNarrowContainer = styled.View<any>`
	display: flex;
	width: 18.75rem;
	flex-direction: column;
	align-items: flex-start;
	background-color: #0a0a0a;
	height: calc(100% - 80px);
	position: fixed;
	align-self: stretch;

	${(props) =>
		props.isSettings &&
		css`
			margin-top: 80px;
			margin-left: 80px;
		`}
`;

export const TabsNarrowContentArea = styled.View<any>`
	${(props) =>
		props.isSettings &&
		css`
			z-index: -1;
			width: 100%;
			padding-top: 4.5rem;
			padding-left: 25.25rem;
			padding-right: 1.5rem;
		`}

	${(props) =>
		!props.isSettings &&
		css`
			z-index: -1;
			width: 100%;
			margin-left: 299px;
		`}
`;

export const StyledTouchableOpacityNarrow = styled.TouchableOpacity<PropsCommonAttributes>`
	display: flex;
	padding: 0.75rem 1rem;
	align-items: left;
	gap: 0.625rem;
	align-self: stretch;
	border-inline-end: ${(props) => (props.shouldHighlight ? "2px solid #2362BE" : 0)};
	background-color: ${(props) => (props.shouldHighlight ? "#182B47" : "transparent")};
`;

export const StyledFont = styled.Text<any>`
	color: ${white};
	font-family: "Nunito";
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 500;
	line-height: 1.5625rem;
	opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export const StyledMainSettingsNarrow = styled.View`
	display: flex;
	padding: 1.5rem 1.5rem;
	gap: 1.5rem;
	width: 100%;
	z-index: -100;
`;

//TabView
export const StyledTextContent = styled.View<PropsCommonAttributes>`
	padding: 20px 25px;
	position: relative;
	z-index: 999;
`;

export const StyledTouchableOpacity = styled.TouchableOpacity<PropsCommonAttributes>`
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	background: ${(props) => (props.shouldHighlight ? "#182B47" : "transparent")};
`;

export const StyledBackgroundView = styled.View`
	position: absolute;
	width: 100%;
	height: 100%;
	background: #2362be;
	opacity: 0.3;
	z-index: 0;
`;

export const StyledBottomBorder = styled.View`
	height: 4px;
	background-color: #2362be;
	width: 100%;
`;

export const StyledContainer = styled.View<Props>`
	position: -webkit-sticky;
	position: sticky;
	flex-direction: row;
	background-color: ${light_black};
	top: ${(props) => (props.isSettings ? "0px" : "112px")};
	z-index: 1;
	padding-left: ${(props) => props.paddingLeft}px;

	${(props) =>
		props.isSettings &&
		css`
			border-bottom-width: 1px;
			border-color: #5a5a5a;
			width: 105%;
			padding-left: ${spacing_l};
		`}
`;

export const TabsContainer = styled.View<Props>`
	${(props) =>
		props.isSettings &&
		css`
			position: fixed;
			margin-left: 90px;
			width: 92%;
		`}
`;
